import React, {useEffect}   from "react"
import useHistoryState from "../useHistoryState"
import { useSelector } from "react-redux"
import {  RootReducer } from "../app/reducer"

 type Props = {
    id? : string,
    name: string,
    label?: string
    postlabel? : string
    reset? : number
}

export const InputTextCl : React.FC<Props> = props  => {
    const windowHistoryState : any = useSelector((state:RootReducer) =>  state.securityResultReducer.secWindowHistoryState );
    const initialValue = "";
    const [inputValue, setInputValue] = useHistoryState(props.name, initialValue);

    useEffect(() => {                       
        if (props.reset !== 0) {
            setInputValue("");            
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.reset])  
        
    //The below useEffect is used to maintain history when moving between pages
    useEffect(() => {                                
        if ( windowHistoryState && windowHistoryState[props.name] ) {
            setInputValue(windowHistoryState[props.name])                
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [windowHistoryState])    
 
    return(
        <div className="search-table-row">
            <span className="search-table-col-left">{props.label}</span>
            <span className="search-table-col-right">
                <input id={props.id} type="text" name={props.name} value={inputValue} onChange={e => setInputValue(e.target.value)} />
                { props.postlabel  && <span className="small">{props.postlabel}</span>}
            </span>
            
        </div>
    )
}

